export default __webpack_public_path__ + "static/media/service-purchase-icon.a12e04bb.svg";